import { render } from "./single-selection.vue?vue&type=template&id=3e6c4e09&lang=pug"
import script from "./single-selection.vue?vue&type=script&setup=true&lang=js"
export * from "./single-selection.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__